import React from "react";
import { Container } from "./Button.Styled";

const Button = ({
  children,
  href,
  style,
  as,
  variants,
  target,
  rel,
  ...rest
}) => {
  const safeRel = target === "_blank" ? rel || "noopener noreferrer" : rel;

  return (
    <Container
      href={href}
      style={style}
      rel={safeRel}
      target={target}
      as={as}
      variants={variants}
      {...rest}
    >
      {children}
    </Container>
  );
};

export default Button;
